// POST /api/ui/trader-management/traders/clients/assign
// Manager przypisuje nieprzypisanego klienta do wybranego handlowca.

import { axios } from 'api';
import { useMutation, useQueryClient, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPostAssignClientToTraderRequest {
  clientId: number;
  traderId: number;
}

export interface IPostAssignClientToTraderResponse {
  status?: number;
  message?: string;
  data?: { clientId: number; traderId: number };
}

const post = (
  payload: IPostAssignClientToTraderRequest,
): Promise<IPostAssignClientToTraderResponse> =>
  axios.post('/trader-management/traders/clients/assign', payload);

export const usePostAssignClientToTrader = (
  options?: UseMutationOptions<
    IPostAssignClientToTraderResponse,
    IError,
    IPostAssignClientToTraderRequest
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostAssignClientToTraderResponse, IError, IPostAssignClientToTraderRequest>(
    (payload) => post(payload),
    {
      ...options,
      onSuccess: async (data, vars, ctx) => {
        await queryClient.invalidateQueries(['trader-management-traders']);
        await queryClient.invalidateQueries(['trader-management-trader-summary']);
        await queryClient.invalidateQueries(['trader-management-unassigned-clients']);
        options?.onSuccess?.(data, vars, ctx);
      },
    },
  );
};
